export enum RemoteMfeNames {
	AccountManagementUI = 'account-management-ui',
	ImageHub = 'image-hub',
}
